import styled from 'styled-components';

interface UserPickerItemSectionProps {
    marginLeft?: number;
}

// eslint-disable-next-line rulesdir/no-styled-export
export const UserPickerItemSection = styled.div`
    display: inline-block;
    margin-left: ${(props: UserPickerItemSectionProps) => `${props && props.marginLeft ? props.marginLeft : 0}px`};
    vertical-align: top;
`;
